import React, { Component } from "react";

import { Link } from "react-router-dom";

import { Element } from "react-scroll";
import Edital from "./Edital";

import axios from "axios";

import Pessoa from "./Pessoa";

export default class Comunidade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edital: [],
      pessoas: [],
    };
  }

  componentDidMount = () => {
    this.loadEditais();
    this.loadPessoas();
  };

  loadPessoas = async () => {
    let res = {};
    try {
      res = await axios.get("/api/pessoas", {
        params: {
          isExecutivo: true,
          isActive: true,
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let pessoas = res.data.arrayPessoas;

    this.setState({ pessoas });
  };

  loadEditais = async () => {
    let res = {};
    try {
      res = await axios.get("/api/avisos", {
        params: {
          frontPage: true,
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let edital = res.data.arrayAvisos;

    this.setState({ edital });
  };

  render() {
    const items = this.state.edital.map(function (item, index) {
      return <Edital item={item} key={index}></Edital>;
    });

    const pessoas = this.state.pessoas.map((item, index) => {
      return <Pessoa item={item} key={index} />;
    });

    return (
      <section id="comunidade-section">
        <Element name="comunidadeElement" />
        <h1>Comunidade</h1>
        <div className="container">
          {pessoas.length === 0 ? (
            <>
              <p>As pessoas responsáveis pela comunidade já voltam.</p>
              <p style={{ marginBottom: "80px" }}>
                Venha procurá-las pelas ruas da aldeia.
              </p>
            </>
          ) : (
            <div className="person-link-container">
              <div className="person-container">{pessoas}</div>
              <div className="see-more">
                <Link to={"/comunidade"}>
                  Ver todos<i className="fas fa-angle-right"></i>
                </Link>
              </div>
            </div>
          )}

          <p className="section-sub-title">Avisos à Comunidade</p>

          {items.length === 0 ? (
            <>
              <p>Não foi ainda necessário avisar a comunidade</p>
              <p style={{ marginBottom: "80px" }}>Aqui, tudo corre bem.</p>
            </>
          ) : (
            <>
              <div className="row">{items}</div>
              <div className="see-more">
                <Link to={"/comunidade"}>
                  Ver mais<i className="fas fa-angle-right"></i>
                </Link>
              </div>
            </>
          )}
        </div>
      </section>
    );
  }
}
